package dev.moetz.chatoverlay.localization

import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json
import org.w3c.dom.get
import org.w3c.dom.set
import web.navigator.navigator

external val require: dynamic

object Localization {

    private const val LANGUAGE_STORAGE_KEY = "selected_language"

    private class LanguageLocalization(val language: Language) {

        val entries: Map<String, String> by lazy {
            val jsonContent = JSON.stringify(require("./locales/${language.identifier}/frontend.json"))
            val content = Json.decodeFromString<Map<String, String>>(jsonContent)
            content
        }

        operator fun get(key: String): String {
            return entries[key].orEmpty()
        }

    }

    private fun getSystemLanguage(): Language {
        val language = if (navigator.languages != undefined) {
            navigator.languages.toList().asSequence().mapNotNull { it.asLanguage }.firstOrNull()
        } else {
            navigator.language.asLanguage
        }
        return language ?: Language.EN
    }

    private var _currentLanguageLocalization: LanguageLocalization

    init {
        val language = localStorage[LANGUAGE_STORAGE_KEY]?.let {
            try {
                Language.valueOf(it)
            } catch (throwable: Throwable) {
                null
            }
        }
        _currentLanguageLocalization = if (language != null) {
            LanguageLocalization(language = language)
        } else {
            LanguageLocalization(language = getSystemLanguage())
        }
    }

    fun setLanguage(language: Language?) {
        _currentLanguageLocalization = LanguageLocalization(language = language ?: getSystemLanguage())
        if (language != null) {
            localStorage[LANGUAGE_STORAGE_KEY] = language.name
        } else {
            localStorage.removeItem(LANGUAGE_STORAGE_KEY)
        }
    }


    enum class Language(val identifier: String) {
        EN("en"),
        DE("de"),
        FR("fr"),
        NL("nl"),
        PL("pl"),
    }

    private val String.asLanguage: Language?
        get() {
            return if (this.contains("-")) {
                Language.entries.firstOrNull {
                    it.identifier.equals(
                        this.substringBefore("-").trim(),
                        ignoreCase = true
                    )
                }
            } else {
                Language.entries.firstOrNull { it.identifier.equals(this.trim(), ignoreCase = true) }
            }
        }

    operator fun get(key: String): String = _currentLanguageLocalization[key]

    fun get(key: String, vararg arguments: Any): String {
        var entry = _currentLanguageLocalization.entries[key].orEmpty()
        arguments.forEachIndexed { index, value ->
            val number = index + 1
            entry = when (value) {
                is Int, is Long -> entry.replace("%$number${'$'}d", value.toString())
                is Float, is Double -> entry.replace("%$number${'$'}f", value.toString())
                else -> entry.replace("%$number${'$'}s", value.toString())
            }
        }
        return entry
    }


}